import config from "environment";
import { getRequest } from "./client";
import { LinkRecordFull } from "winslow-core";

const { baseApi } = config;

export interface DocumentChunk {
  id: string;
  collectionId: string;
  linkRecordId: string;
  content: string;
  chunkNumber: number;
  totalChunks: number;
}

export interface LinkRecordContentResponse {
  content: string;
  chunks: DocumentChunk[];
  totalChunks: number;
}

export async function apiGetWorkspaceLinkRecords(
  workspaceId: string
): Promise<LinkRecordFull[] | null> {
  const fetchURL = `${baseApi}/workspaces/link-records/${workspaceId}`;
  return await getRequest<LinkRecordFull[]>(
    fetchURL,
    "API/apiGetWorkspaceLinkRecords"
  );
}

export async function apiGetLinkRecordContent(
  linkRecordId: string
): Promise<LinkRecordContentResponse | null> {
  const fetchURL = `${baseApi}/employees/admin/link-record/${linkRecordId}/content`;
  return await getRequest<LinkRecordContentResponse>(
    fetchURL,
    "API/apiGetLinkRecordContent"
  );
}

